module.exports = __webpack_public_path__ + "media/email.610f3a4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/outSide/assets/img/email.svg
// module id = ./src/templates/outSide/assets/img/email.svg
// module chunks = 0